export enum IncomeOption {
    INCOME_INPUT,
    DATE_OF_BIRTH,
    AOW10YEARS_INFO,
    STARTERS_DISPENSATION,
    STARTERS_DISPENSATION_INFO,
    SUMMARY
}

export enum StartersDispensationQuestion {
    STARTERS_DISPENSATION_BUTTON,
    SUMMARY
}
